<div class="border rounded shadow text-color-blue1 flex w-auto md:w-[600px] h-full p-4 gap-4 flex-col md:flex-row"
     *transloco="let t; read 'company.card';">
  <div class="w-auto md:w-[250px] h-[200px] rounded bg-center bg-contain bg-no-repeat"
       [style.background-image]="'url(' + (company.logo ? ('data:image/jpg;base64,' + company.logo) : 'assets/images/inspector_panel.webp') + ')'">
  </div>
  <div class="w-full flex flex-col gap-3 justify-around">
    <div>
      <div class="flex justify-between items-center">
        <h2>{{company.companyName}}</h2>
      </div>
      <psc-line></psc-line>
    </div>
    <div class="flex flex-col gap-2">
      <div class="flex gap-4"
           *ngFor="let info of infoArray; let first = first"
           [ngClass]="{'font-bold text-xl': first}">
        <mat-icon>{{info.icon}}</mat-icon>
        <div>{{info.value || '-'}}</div>
      </div>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
